export default "__VITE_ASSET__CYk4rqnR__"